import React from "react";

export interface ISeparatorProps {
    title: string;
}
export default function Separator(props: ISeparatorProps){
return (
    <h2 className={`text-center`}>{props.title}</h2>
)
}